import React from "react";
import { Button } from "@mui/material";

export default function PinkOutlinedButton({
  startIcon,
  buttonTitle,
  onClick,
  height
}) {
  return (
    <Button
      variant="outlined"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      sx={{
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 700,
        height:height ? height : "36px",
        textTransform: "none",
        border:"2px solid #9D0385",
        color: "#9D0385",
        px: 3,
        fontFamily:"Inter",
        "&:hover" :{
         border:"2px solid #9D0385",
        }
       
      }}
    >
      {buttonTitle}
    </Button>
  );
}
